import { NgModule } from "@angular/core";
import { MenuModule } from "../../menu/menu.module";
import { ErtUserViewComponent } from "./ert-user-view.component";
import { MaterialModule } from "../../material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedImportsModule } from "../../shared/shared-imports.module";
import { SharedModule } from "../../shared.module";

const componentList = [ErtUserViewComponent];

@NgModule({
  imports: [
    MenuModule,
    SharedImportsModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
  ],
  declarations: [componentList],
})
export class ERTUserViewModule {}
